import { assert } from '@varos/util-typescript';
import { TaskItemLoader } from './taskItemInterface';
import { ReportingLoaderBaseConfig } from '../../../base';

const POLL_INTERVAL_MS = 15000;

export function createTaskItemLoader(config: ReportingLoaderBaseConfig): TaskItemLoader {
    const {
        repository: { research: repository },
    } = config;
    return {
        useLoad(context, props) {
            const statusQuery = repository.taskStatus.useFind(
                context,
                {
                    task: props.task.id,
                },
                {
                    suspense: true,
                    keepPreviousData: true,
                    refetchInterval(data, query) {
                        if (props.task.status !== 'in_progress') {
                            return false;
                        }
                        return POLL_INTERVAL_MS;
                    },
                }
            );
            assert(statusQuery.status === 'success', 'expected suspense');
            return {
                task: props.task,
                statuses: statusQuery.data,
            };
        },
    };
}
